import { render, staticRenderFns } from "./showSecond.vue?vue&type=template&id=04990bf8&scoped=true&"
import script from "./showSecond.vue?vue&type=script&lang=js&"
export * from "./showSecond.vue?vue&type=script&lang=js&"
import style0 from "./showSecond.vue?vue&type=style&index=0&id=04990bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04990bf8",
  null
  
)

export default component.exports